var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-btn",class:{ unseen: _vm.notifications.length > 0}},[_c('img',{staticClass:"bell",attrs:{"src":require("../assets/icon/alarm.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }